
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(\-webpack_sharing_consume_default_react_react\-_(114c|9ae8|bfc2|c15d)|webpack_sharing_consume_default_(emotion_cache_emotion_cache\-webpack_sharing_consume_default_r\-d9d3da|react\-dom_react\-dom))$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
